import { TRatingType } from '../../types/filters';

export const changeUrl = (type: TRatingType, slug: string) => {
  const typeRedirect = type === 'all' ? '' : `-${type}`;
  history.pushState(null, '', `/top-${slug}${typeRedirect}`);
};

export const redirectUrl = (type: TRatingType, slug: string) => {
  const typeRedirect = type === 'all' ? '' : `-${type}`;
  window.location.href = `/top-${slug}${typeRedirect}`;
};
